import { useSelector } from "react-redux";
import { LeftNavBar } from "../../SharedModule/components/LeftNavBar";
import { LeftNavBarSection } from "../../SharedModule/components/LeftNavBarSection";
import {
  ROUTE_USERS,
  ROUTE_USERS_BAMBOO_PROFILE,
  USERS_ADMIN_ACCESS,
  USERS_ALL_ROLES,
} from "../../SharedModule/utils/constants";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";

export const LeftNavBarUsers = (props: any) => {
  const { userRolesList } = useSelector(selectUserRoles);

  return (
    <LeftNavBar>
      <LeftNavBarSection
        mainTitle="Users"
        biIconName="BiUserPin"
        roleRequired={USERS_ALL_ROLES}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "User List",
            route: ROUTE_USERS,
            requireModuleAccess: false,
            roleRequired: USERS_ALL_ROLES,
            actualUserRoles: userRolesList,
            onClick: () => localStorage.removeItem("userScrollY"),
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reports"
        biIconName="BiBarChartAlt2"
        requireModuleAccess={true}
        roleRequired={USERS_ADMIN_ACCESS}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "BambooHR Profile import",
            route: ROUTE_USERS_BAMBOO_PROFILE,
            requireModuleAccess: true,
            roleRequired: USERS_ADMIN_ACCESS,
          },
        ]}
      />
    </LeftNavBar>
  );
};
